import Reveal from "@/components/Reveal";
import { SITE } from "@/lib/site";

const ABOUT_IMG =
  "https://images.pexels.com/photos/5775099/pexels-photo-5775099.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const FILE_ROWS = [
  ["Business", "Eli Capital Investments"],
  ["Address", "16234 NW 1st Street, Pembroke Pines, FL 33028"],
  ["Phone", "954-702-3558"],
  ["Email", "elicapitalinvestments@gmail.com"],
  ["Focus", "Wholesale · Import / Export"],
  ["Model", "Sourcing & coordination — no warehouse, no retail floor"],
];

const About = () => (
  <section id="about" className="py-24 md:py-32" data-testid="about-section">
    <div className="max-w-[1240px] mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
      <div>
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-accent" data-testid="about-eyebrow">
            About Us
          </p>
          <h2
            className="mt-5 font-display font-extrabold text-ink tracking-[-0.02em] leading-[1.02] text-[clamp(2rem,4.2vw,3.4rem)]"
            data-testid="about-heading"
          >
            A sourcing house, not a storefront.
          </h2>
        </Reveal>

        <Reveal delay={0.08}>
          <p className="mt-7 text-[17px] leading-relaxed text-slate-600" data-testid="about-para-1">
            Eli Capital Investments is a wholesale merchandise and import/export sourcing
            company based in Pembroke Pines, Florida. We primarily source and coordinate
            merchandise orders across a wide range of product categories — and we do it
            without a warehouse or retail storefront. Any inventory we occasionally hold is
            limited to small quantities.
          </p>
          <p className="mt-5 text-[17px] leading-relaxed text-slate-600" data-testid="about-para-2">
            That model keeps our catalog flexible and our overhead low: when you call, we
            find the merchandise, coordinate the order, and arrange the move to your
            destination.
          </p>
        </Reveal>

        <Reveal delay={0.14} className="mt-10">
          <div className="overflow-hidden rounded-2xl" data-testid="about-image-frame">
            <img
              src={ABOUT_IMG}
              alt="Warehouse aisle with organized shelves of boxed wholesale goods"
              className="w-full h-[260px] md:h-[320px] object-cover"
              loading="lazy"
              data-testid="about-image"
            />
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1} className="lg:pt-16">
        <div className="border border-slate-200 rounded-2xl bg-surface p-7 md:p-9" data-testid="about-company-file">
          <div className="flex items-center justify-between">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-slate-400">
              Company file
            </p>
            <span className="h-2 w-2 rounded-full bg-accent inline-block" aria-hidden="true" />
          </div>
          <dl className="mt-7 space-y-5">
            {FILE_ROWS.map(([k, v]) => (
              <div key={k} className="grid grid-cols-[96px_1fr] gap-4 items-start">
                <dt className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate-400 pt-1">
                  {k}
                </dt>
                <dd className="text-[14px] leading-relaxed font-medium text-ink">{v}</dd>
              </div>
            ))}
          </dl>
          <div className="mt-7 h-7 barcode-strip rounded-sm" aria-hidden="true" />
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
